<ngx-spinner>
  <img [src]='environment1 + "assets/images/Loading-truck.gif"' alt="Loading-truck" width="200px" />
</ngx-spinner>
<div class="conf-container">
  <app-header
    *ngIf="this.router.url !== '/login' && this.router.url !== '/welcome' && this.router.url !== '/' && this.router.url !== '/otp' &&  this.router.url !== '/signup' &&  !this.router.url.includes('/configurator') && !this.router.url.includes('/intro') && !this.router.url.includes('/product-lead') && !this.router.url.includes('/advancesearch') && !this.router.url.includes('/finance-product-lead') && !this.router.url.includes('/?dealer=')"></app-header>
  <div class="section">
    <router-outlet></router-outlet>
    <app-footer *ngIf="this.router.url !== '/login' && this.router.url !== '/' && this.router.url !== '/welcome' &&
      this.router.url !== '/otp' &&  this.router.url !== '/signup' &&
      !this.router.url.includes('/configurator') &&  !this.router.url.includes('/intro') && !this.router.url.includes('/product-lead')  && !this.router.url.includes('/advancesearch') && !this.router.url.includes('/finance-product-lead') && !this.router.url.includes('/?dealer=')
"></app-footer>
  </div>
</div>

<!-- //anuvadak -->
 <!-- <div class="anuvadak-dflex anuvadak-justify-content-center anuvadak-widget" id="anuvadak-language-svg"><div style="text-align:left; padding:'0 10px'">
  <div style="opacity:0.8;text-align: center;">Language</div>
  <div class="avk-currently-active-language" style="
      display: flex;
      justify-content: space-between;
  ">


<div id="anuvadak-language-selector-container" >
   <select class="anuvadak-select cursor-pointer"
  id="anuvadak-language-selector-list">
  <option value="english"
  anuvadak-no-localization="true">English</option>
  <option value="hindi"
  anuvadak-no-localization="true">Hindi</option>
  <option value="marathi"
  anuvadak-no-localization="true">Marathi</option>
  <option value="odia"
  anuvadak-no-localization="true">Gujarati</option>
  <option value="odia"
  anuvadak-no-localization="true">Malayalam</option>
  <option value="odia"
  anuvadak-no-localization="true">Punjabi</option>
  <option value="odia"
  anuvadak-no-localization="true">Telugu</option>
  <option value="odia"
  anuvadak-no-localization="true">Tamil</option>
  <option value="odia"
  anuvadak-no-localization="true">Bengali</option>
  <option value="odia"
  anuvadak-no-localization="true">Odia</option>
  <option value="odia"
  anuvadak-no-localization="true">Assamese</option>
  <option value="odia"
  anuvadak-no-localization="true">Kannada</option>
  </select>
  </div>
 <svg height="10" width="10" class="blinking anuvadak-blink">
    <circle cx="10" cy="10" r="10" fill="red" />
  </svg>
</div>
</div>
</div> -->
<!-- <app-advance-search></app-advance-search> -->
